module.exports = __webpack_public_path__ + "img/micrositeimg2.1000e6dd.jpg";